import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import HowItWorksItems from 'components/Common/HowItWorks/HowItWorksItems'
import LineAngleLeftIcon from 'components/Luxkit/Icons/line/LineAngleLeftIcon'
import LastMinuteBanner from './LastMinuteBanner'
import { getImageUrl } from 'lib/image/imageUtils'
import TextLink from 'components/Luxkit/TextLink'
import { connect } from 'react-redux'
import BodyText from 'components/Luxkit/Typography/BodyText'

const LAST_MINUTE_BANNER_IMAGE_ID = 'wos0ggdgm5dtp14y99la'

const StyledPane = styled(Pane)`
  background-image: url(${getImageUrl(LAST_MINUTE_BANNER_IMAGE_ID, { aspectRatio: '5:1', brightness: -30 })});
  background-size: cover;
  background-position: 50%;
  padding: ${rem(20)};
  color: ${props => props.theme.palette.neutral.default.eight};
`

const StyledGrid = styled(LayoutContainer)`
  margin-top: ${rem(16)};
`

const howItWorksItems: Array<any> = [{
  icon: 'calendarIcon',
  title: 'Travel in the next 2 weeks',
  iconSize: 30,
  iconType: null,
  light: true,
}, {
  icon: 'handpicked-partner',
  title: 'Best rates',
  light: true,
  iconSize: 30,
  iconType: null,
}, {
  icon: 'vip-inclusions',
  title: 'Exclusive extras',
  light: true,
  iconSize: 30,
  iconType: null,
}]

interface Props {
  headlessMode: boolean;
}

function LastMinuteHero(props: Props) {
  return (
    <StyledPane>
      <LayoutContainer>
        {!props.headlessMode && <TextLink variant="ghost" size="medium" startIcon={<LineAngleLeftIcon />} to="/">
          All escapes
        </TextLink>}
      </LayoutContainer>
      <StyledGrid size="xs">
        <LastMinuteBanner preserveAspectRatio="xMidYMin slice" width={undefined} height={undefined} />
      </StyledGrid>
      <BodyText colour="neutral-eight" variant="large" align="center" as="p">
        Unbeatable hotel offers for spur-of-the-moment stays
      </BodyText>
      <LayoutContainer size="xs">
        <PaneBody size="xl-y" mobileSize="lg-y">
          <HowItWorksItems items={howItWorksItems} />
        </PaneBody>
      </LayoutContainer>
    </StyledPane>
  )
}

function mapStateToProps(state: App.State) {
  return {
    headlessMode: state.system.headlessMode,
  }
}

export default connect(mapStateToProps)(LastMinuteHero)
